const formatter = new Intl.NumberFormat('vi-VN', {
  style: 'currency',
  currency: 'VND',
  maximumFractionDigits: 0,
});

export function formatVnd(amount: number | string | null | undefined): string {
  if (amount === null || amount === undefined || amount === '') return '0 ₫';
  const n = typeof amount === 'string' ? Number(amount) : amount;
  if (!Number.isFinite(n)) return '0 ₫';
  return formatter.format(n);
}

export function parseVndInput(input: string): number {
  const digits = input.replace(/[^\d]/g, '');
  return digits === '' ? 0 : Number(digits);
}
